import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Ministry } from "../../../../profile/domain/ministry/ministry";
import { GlobalAppService } from "../../../../core/commons/global-app.service";
import { MinistryService } from "../../../../profile/service/ministry.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageSeverity } from "../../../../core/commons/message-severity";
import { Address } from "../../../../profile/domain/address";
import { ProvinceService } from "../../../../profile/service/province.service";
import { Province } from "../../../../profile/domain/province";
import { CityService } from "../../../../profile/service/city.service";
import { City } from "../../../../profile/domain/city";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-ministry-form",
  templateUrl: "./ministry-form.component.html",
  styleUrls: ["./ministry-form.component.scss"]
})
export class MinistryFormComponent implements OnInit, OnDestroy {
  ministry: Ministry = null;
  address: Address = null;
  provincesList: Province[] = null;
  citiesList: City[] = null;
  title = "";
  selectedProvince: Province;
  selectedCity: City;
  ministryForm: FormGroup;
  isNew = false;

  constructor(
    private ministryService: MinistryService,
    private provinceService: ProvinceService,
    private cityService: CityService,
    private fb: FormBuilder,
    private appService: GlobalAppService,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {
    this.ministryForm = this.fb.group({
      name: ["", [Validators.required, Validators.minLength(5)]],
      address: this.fb.group({
        street: ["", [Validators.minLength(5), Validators.required]],
        province: [null, [Validators.required]],
        city: [null, [Validators.required]]
      })
    });
  }

  ngOnDestroy(): void {}

  ngOnInit() {
    this.provinceService.getAll().subscribe(provinces => {
      this.provincesList = provinces;
    });

    this.ministryForm
      .get("address")
      .get("province")
      .valueChanges.subscribe(province => {
        if (province) {
          this.appService.setLoading(true);
          this.selectedProvince = province;
          this.selectedCity = null;
          this.citiesList = null;

          this.cityService
            .getCitiesByProvinceId(province.id)
            .subscribe(cities => {
              this.appService.setLoading(false);
              this.citiesList = cities;
            });

        }
      });

    const $id = this.route.params.map(params => params["id"]);

    $id
      .filter(id => id !== "new")
      .switchMap(id => this.ministryService.get(+id))
      .do(id => (this.isNew = false))
      .subscribe(
        ministry => {
          this.ministry = ministry;

          this.title = "Editar el ministerio";
          this.selectedProvince = this.ministry.address.city.province;
          this.selectedCity = this.ministry.address.city;

          this.ministryForm.setValue({
            name: ministry.name,
            address: {
              street: ministry.address.street,
              province: this.selectedProvince,
              city: this.selectedCity
            }
          });
          this.cd.markForCheck();
        },
        error => {
          this.appService.sendMsg(
            MessageSeverity.ERROR,
            "Error:",
            "El ministerio no existe en el sistema."
          );
          this.router.navigate(["home", "ministry"]);
        }
      );

    $id
      .filter(id => id === "new")
      .do(id => (this.isNew = true))
      .subscribe(ministry => {
        this.title = "Nuevo ministerio";
        this.ministry = new Ministry();
        this.cd.markForCheck();
      });
  }

  compareProvinces(p1: Province, p2: Province): boolean {
    return p1.equals(p2);
  }

  compareCities(c1: City, c2: City): boolean {
    return c1.equals(c2);
  }

  formToEntity(form: FormGroup): Ministry {
    const formValue = form.value;

    const address = new Address({
      street: formValue.address.street,
      city: formValue.address.city
    });
    const m = new Ministry({
      id: this.ministry.id,
      name: formValue.name,
      address: address
    });
    return m;
  }

  getNameErrorMessage() {
    return this.ministryForm.get("name").hasError("minlength")
      ? "Este campo debe tener más de 5 letras."
      : this.ministryForm.get("name").hasError("required")
      ? "Este campo es requerido."
      : "";
  }

  getStreetErrorMessage() {
    return this.ministryForm.get("address.street").hasError("minlength")
      ? "Este campo debe tener más de 5 letras."
      : this.ministryForm.get("address.street").hasError("required")
      ? "Este campo es requerido."
      : "";
  }

  public saveMinistry() {
    this.appService.setLoading(true);
    this.ministry = this.formToEntity(this.ministryForm);
    if (!this.isNew) {
      this.ministryService.update(this.ministry).subscribe(
        m => {
          this.appService.sendMsg(
            MessageSeverity.SUCCESS,
            "Guardado",
            "Se ha guardado el ministerio correctamente"
          );
          this.appService.setLoading(false);
          this.goBack();
        },
        error => {
          this.appService.sendMsg(
            MessageSeverity.ERROR,
            "Error: " + error.json().error,
            "No se a podido guardar el ministerio. " + error.json().message
          );
          this.appService.setLoading(false);
        }
      );
    } else {
      this.ministryService.create(this.ministry).subscribe(
        user => {
          this.appService.sendMsg(
            MessageSeverity.SUCCESS,
            "Guardado",
            "Se ha creado el ministerio correctamente"
          );
          this.appService.setLoading(false);
          this.goBack();
        },
        error => {
          this.appService.sendMsg(
            MessageSeverity.ERROR,
            "Error: " + error.json().error,
            "No se a podido crear el ministerio. " + error.json().message
          );
          this.appService.setLoading(false);
        }
      );
    }
    event.preventDefault();
  }

  public goBack() {
    this.router.navigate(["home", "ministry"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/ministries/ministry-form/ministry-form.component.ts